import { ChatCircle, ToggleLeft, ToggleRight, CalendarBlank } from "@phosphor-icons/react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const DAYS = [
  { value: 0, label: "Lunedì" },
  { value: 1, label: "Martedì" },
  { value: 2, label: "Mercoledì" },
  { value: 3, label: "Giovedì" },
  { value: 4, label: "Venerdì" },
  { value: 5, label: "Sabato" },
  { value: 6, label: "Domenica" },
];

export default function CheckinHeader({ enabled, dayOfWeek, saving, onToggle, onChangeDay }) {
  return (
    <div className="bg-[#171717] border border-[#262626] rounded-lg p-5">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-[#007AFF]/15 flex items-center justify-center flex-shrink-0">
            <ChatCircle size={20} weight="duotone" className="text-[#007AFF]" />
          </div>
          <div className="min-w-0">
            <h3
              className="text-lg font-bold tracking-tight uppercase text-white"
              style={{ fontFamily: "Barlow Condensed, sans-serif" }}
            >
              CHECK-IN SETTIMANALE
            </h3>
            <p className="text-[12px] text-zinc-500 mt-0.5 max-w-xl">
              Il cliente compila un breve modulo ogni settimana. I dati ti aiutano a vedere
              trend di energia, sonno, aderenza al programma e ad anticipare problemi.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={onToggle}
          disabled={saving}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition-colors flex-shrink-0 ${
            enabled
              ? "bg-[#34C759]/15 text-[#34C759] border border-[#34C759]/30"
              : "bg-[#171717] border border-[#262626] text-zinc-400 hover:text-white"
          }`}
          data-testid="checkin-toggle-enabled"
        >
          {enabled ? <ToggleRight size={16} weight="fill" /> : <ToggleLeft size={16} />}
          {enabled ? "ATTIVO" : "DISATTIVO"}
        </button>
      </div>
      {enabled && (
        <div className="flex items-center gap-3 mt-4 pt-4 border-t border-[#262626]">
          <CalendarBlank size={14} className="text-zinc-500" />
          <Label className="text-zinc-400 text-xs uppercase tracking-wider">
            Giorno di apertura
          </Label>
          <Select value={String(dayOfWeek)} onValueChange={onChangeDay}>
            <SelectTrigger
              className="w-40 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="checkin-day-select"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              {DAYS.map((d) => (
                <SelectItem key={d.value} value={String(d.value)} className="text-white">
                  {d.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
